import type { SVGProps } from "react";
export const Facebook = (props: SVGProps<SVGSVGElement>) => (
	<svg
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 20 20"
		aria-hidden={true}
		{...props}
	>
		<path
			d="M14.0088 11.125L14.5087 7.86742H11.383V5.75348C11.383 4.86227 11.8196 3.99355 13.2195 3.99355H14.6405V1.22008C14.6405 1.22008 13.351 1 12.1181 1C9.54395 1 7.86137 2.56023 7.86137 5.38469V7.86742H5V11.125H7.86137V19H11.383V11.125H14.0088Z"
			fill="currentColor"
		/>
	</svg>
);
